'use client';

import type { ReactElement } from 'react';

import styles from './CertikHighlightTooltip.module.scss';

const highlightsLabelMap: Record<string, string> = {
  audit_history: 'Project’s audit history available',
  bug_bounty: 'Project has an on-going bug bounty',
  coderepo_health: 'Code repo health is in excellent condition',
  kyc: 'Team has successfully passed KYC verification',
  market_cap: "Project's market cap is in",
  team_identity: 'Core team members are identifiable',
  token_activity: 'Project’s token activity is in',
  trading_volume: 'Project’s trading volume is in',
  twitter_follower: 'Project’s twitter followers are in',
};

const alertsLabelMap: Record<string, string> = {
  audit_history: 'Requires further assessment on security audits',
  audit_history_2: 'No security audit is publicly available',
  coderepo_health: 'Code repo health is below average',
  price_slippage: 'Price slippage detected within the last three months',
  team_identity: 'Core team members are anonymized',
  twitter_closure: "Project's twitter account was closed or suspended",
};

const informationLabelMap: Record<string, string> = {};

const warningLabelMap: Record<string, string> = {};

const getLabelMap = (title: string): Record<string, string> => {
  switch (title) {
    case 'Highlights':
      return highlightsLabelMap;
    case 'Information':
      return informationLabelMap;
    case 'Warning':
      return warningLabelMap;
    case 'Danger':
      return alertsLabelMap;
    default:
      return {};
  }
};

interface Item {
  label: string;
  data?: number;
}

interface CertikHighlightTooltipProps {
  title: string;
  items?: Item[];
  children: ReactElement;
  Icon: ReactElement;
}

export const CertikHighlightTooltip = ({
                                         title,
                                         items = [],
                                         children,
                                         Icon,
                                       }: CertikHighlightTooltipProps) => {
  const hasItems = items?.length > 0;
  const labelMap = getLabelMap(title);

  if (!hasItems) {
    return children;
  }

  return (
    <div className={styles['container']}>
      {children}
      <div className={styles['tooltip']}>
        <div className={styles['title']}>{title}</div>
        <ul className={styles['list']}>
          {items?.map((item, i) => {
            const labelText = labelMap[item.label] ?? item.label;
            const percent = item.data != null ? `${Math.round(item.data * 100)}%` : '';
            return (
              <li key={i} className={styles['item']}>
                {Icon}
                {labelText} {percent}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
